import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { GfTranslateService } from '../../../core/services/core.translate.service';;
import { UserService } from '../../../core/services/core.user.service';
import { UserRest } from '../../../core/services/core.user.rest.service';
import { TrackerRest } from './tracker.rest';
import { TrackerService } from './tracker.service';
import { TrackerFilterService } from './tracker.filter.service';

@Injectable()
export class TrackerQueryService {
	urlQuery: string;
	queryFieldTypesToAlias: any;
	aliasToQueryFieldType: any;
	queryFieldTypes: any;
	assigneeSpecialFilters: any;
	statusSpecialFilters: any;

    constructor(
		private trackerService: TrackerService, 
		private trackerRest: TrackerRest, 
		private userRest: UserRest, 
		private userService: UserService, 
		private translateService: GfTranslateService,
		private stateService: StateService,
		private trackerFilterService: TrackerFilterService
	) {

		this.urlQuery = '/api/tracker/:trackerId/query/:queryId';
		this.queryFieldTypesToAlias = {
			FIELD_ASSIGNEE: "assignees",
			FIELD_PRIORITY: "priority",
			FIELD_TRACKERSPRINT: "sprint",
			FIELD_WAITINGFOR: "waitingFor",
			FIELD_LOCK_STATUS: "lockStatus",
			FIELD_SUMMARY: "summary",
			FIELD_DETAILS: "details",
			FIELD_SUBMITTEDBY: "submittedBy",
			FIELD_STORY_POINTS: "storyPoints",
			FULL_TEXT_SEARCH: "_textsearch",
			PARENT_CHILD_RELATIONSHIP: "parentChildRelationship",
			ATTACHMENTS: "attachments"
		};
		this.aliasToQueryFieldType = {
			assignees: "FIELD_ASSIGNEE",
			priority: "FIELD_PRIORITY",
			sprint: "FIELD_TRACKERSPRINT",
			waitingFor: "FIELD_WAITINGFOR",
			openDate: "FIELD_OPENDATE",
			closeDate: "FIELD_CLOSEDATE",
			lastModifiedDate: "FIELD_MODDATE",
			lockStatus: "FIELD_LOCK_STATUS",
			_textsearch: "FULL_TEXT_SEARCH",
			summary: "FIELD_SUMMARY",
			submittedBy: "FIELD_SUBMITTEDBY",
			details: "FIELD_DETAILS",
			extraField: "FIELD_EXTRAFIELD",
			attachments: "ATTACHMENTS",
			parentChildRelationship: "PARENT_CHILD_RELATIONSHIP",
			storyPoints: "FIELD_STORY_POINTS"		
		};
		this.queryFieldTypes = {
			FIELD_ASSIGNEE      : "1",
			FIELD_MODDATE       : "3",
			FIELD_EXTRAFIELD    : "4",
			FIELD_SORTCOL       : "5",
			FIELD_SORTORD       : "6",
			FIELD_OPENDATE      : "7",
			FIELD_CLOSEDATE     : "8",
			FIELD_LIST          : "9",
			FIELD_PRIORITY      : "10",
			FIELD_TRACKERSPRINT : "11",
			FIELD_WAITINGFOR	  : "12",
			FIELD_SUMMARY       : "20",
			FIELD_DETAILS       : "21",
			FIELD_SUBMITTEDBY   : "22",
			FIELD_RELEASE       : "13",
			FIELD_LOCK_STATUS   : "23",
			FULL_TEXT_SEARCH	  : "24",
			ATTACHMENTS		  : "25",
			PARENT_CHILD_RELATIONSHIP: "26",
			FIELD_STORY_POINTS  : "27"		
		};
		this.assigneeSpecialFilters = {
			"-1": {id: "-1", value: "-1", label: 'Current User'},
			"-2": {id: "-2", value: "-2", label: 'Any User'}
		};
		this.statusSpecialFilters = {
			"-3": {id: "-3", value: "-3", label: 'Any open status'},
			"-4": {id: "-4", value: "-4", label: 'Any closed status'}
		};
    }

	/**
	 * Given a query id retrieve the query configuration object
	 * 
	 * @param queryId 
	 * @returns 
	 */
	public getQuery(queryId, tracker) {
		return new Promise((resolve, reject) => {
			if (queryId.toString().match(/(custom)/i)) {
				return this.getCustomQueryParams(tracker.id)
					.then((queryParams) => {
						this.mapQueryParamsToQueryObject(queryParams, tracker);
						resolve(null);
					}, () => {
						reject();
					});
			} else {
				this.trackerRest.query(0, queryId)
				.then(() => {
					resolve(null);
				}, () => {
					reject();
				})
			}
		});
	}

	/**
	 * Maps adHoc query params (key: value) into a query object
	 * 
	 * @param queryParams 
	 * @param tracker 
	 * @returns 
	 */
	public mapQueryParamsToQueryObject(queryParams, tracker) {
		var query: any = {
			queryFields: []
		},
		paramValue;

		for (var alias in queryParams) {
			switch(alias) {
				case 'priority':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_PRIORITY, 
						typeName: this.aliasToQueryFieldType.priority, value: paramValue});
					break;

				case 'sprint':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_TRACKERSPRINT, 
						typeName: this.aliasToQueryFieldType.sprint, value: paramValue});
					break;

				case 'assignees':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_ASSIGNEE, 
						typeName: this.aliasToQueryFieldType.assignees, value: paramValue});
					break;

				case 'details':
					query.queryFields.push({type: this.queryFieldTypes.FIELD_DETAILS, 
						typeName: this.aliasToQueryFieldType.details, value: queryParams[alias]});
					break;

				case 'lockStatus':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_LOCK_STATUS, 
						typeName: this.aliasToQueryFieldType.lockStatus, value: paramValue});
					break;

				case 'waitingFor':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_WAITINGFOR, 
						typeName: this.aliasToQueryFieldType.waitingFor, value: paramValue});
					break;

				case 'storyPoints':
					paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
					query.queryFields.push({type: this.queryFieldTypes.FIELD_STORY_POINTS, 
						typeName: this.aliasToQueryFieldType.storyPoints, value: paramValue});
					break;

				default:
					var trackerField = _.get(tracker, 'fields[\'' + alias + '\']', null);
					if (!_.isEmpty(trackerField)) {
						if ([1,3,7,8,2,5,12].includes(trackerField.fieldType) && !trackerField.useWorkflow) {
							paramValue = (queryParams[alias]) ? queryParams[alias].toString() : '';
							query.queryFields.push({id: trackerField.id, type: this.queryFieldTypes.FIELD_EXTRAFIELD, 
								typeName: this.aliasToQueryFieldType.extraField, value:paramValue});
						}
					}
					break;
			}
		}

		return query;
	}

	/**
	 * Given a query configuration object, map query filter values on intrinsic
	 * and extra fields to field values in the trackeritem object
	 * 
	 * @param trackeritem {object}
	 * @param tracker {object}
	 * @param query {object}
	 */
	public mapFilterValueToFieldValue(trackeritem, tracker, query) {
		_.forEach(_.get(query, 'queryFields', []), (filter) => {
			if (!_.isEmpty(filter.value)) {
				switch(filter.typeName) {
					case this.aliasToQueryFieldType.assignees:
						var values = filter.value.split(','), assignee;

						if (values.length > 0) {
							_.forEach(values, (value) => {
								assignee = _.find(_.get(tracker, 'rel.assignees', []), {id: parseInt(value)});

								if (!_.isEmpty(assignee)) {									
									trackeritem.rel.assignees.push(assignee);
								}	
							})
						}
						break;

					case this.aliasToQueryFieldType.priority:
						if (['1','2','3','4','5'].includes(filter.value)) {
							trackeritem.priority = parseInt(filter.value);
						}
						break;

					case this.aliasToQueryFieldType.sprint:
						var sprint: any = _.find(tracker?.fields?.sprint?.fieldElements, {id: parseInt(filter.value)});
						if (!_.isEmpty(sprint)) {
							trackeritem.sprint.fieldData = sprint;
						}	
						break;

					case this.aliasToQueryFieldType.waitingFor:
						trackeritem.waitingFor = filter.value;
						break;

					case this.aliasToQueryFieldType.summary:
						trackeritem.summary = filter.value;
						break;

					case this.aliasToQueryFieldType.lockStatus:
						trackeritem.lockStatus = filter.value;
						break;

					case this.aliasToQueryFieldType.storyPoints:
						trackeritem.storyPoints = filter.value;
						break;

					case 'FIELD_EXTRAFIELD':
						var tef: any, tefTi: any;

						//Find extra field in the tracker object
						for (const key in tracker.fields) {
							if (key?.length > 0 && tracker.fields[key].id == filter.id) {
								tef = tracker.fields[key];
								break;
							}
						}

						//If extra field exists
						if (!_.isEmpty(tef) && [1,3,8,2,5,12].includes(tef.fieldType)) {
							//Find corresponding extra field in trackeritem object
							tefTi = _.get(trackeritem, 'extraFields[\'' + tef.alias + '\']', null);

							if (!_.isEmpty(tefTi)) {
								var values = filter.value.split(',');

								if (values.length > 0) {
									//Single select fields
									if ([1,3,7,8].includes(tef.fieldType)) {
										var tefe: any = _.find(_.get(tef, 'fieldElements', []), {id: parseInt(values[0])});
										if (!_.isEmpty(tefe)) {
											tefTi.fieldData = tefe;
										}
									} else if ([2,5,12].includes(tef.fieldType)) {
										var tefe: any;
										tefTi.fieldData = [];
										_.forEach(values, (value) => {
											tefe = _.find(_.get(tef, 'fieldElements', []), {id: parseInt(value)});

											if (!_.isEmpty(tefe)) {
												tefTi.fieldData.push(tefe);
											}	
										})
									}

								}
							}
						}
						break;
				}
			}
		});
	}

	/**
	 * Given a list of queries and a query id, returnes the query object
	 * Mutates the queries list
	 *
	 * @param {array} of query objects
	 * @param {int}   query to find
	 * @returns {obect} query object
	 */
	public getQueryObject(queries, queryId) {
		return _.map(queries, (tracker) => {
			return tracker.queries;
		}).flat().find((queryObj) => {
			return (queryObj.id == queryId);
		});
	}

	/**
	 * Given a list of queries, adds a custom query item for each tracker
	 * Mutates the queries list
	 *
	 * @param {array} of query objects
	 * @returns {array} of query objects
	 */
	public addCustomQueries(queryList) {
		return _.map(queryList, (tracker) => {
			//Sort tracker queries
			tracker.queries = _.sortBy(
				_.get(tracker, 'queries', []),
				['queryName']
			);

			// Add custom query
			tracker.queries.unshift(this.getCustomQuery(tracker));

			return tracker;
		});
	}

	public getCustomQuery(tracker) {
		return {
			id: 'custom_' + tracker.id,
			isDefault: true,
			isShared: false,
			queryFields: [],
			queryName: this.translateService.translate('Quick Filter'),
			isCustom: true,
			tracker: _.cloneDeep(tracker)
		};
	}

	/**
	 * Given a list of queries, returns a list of queries
	 * grouped by tracker
	 *
	 * @param {array} of query objects
	 * @returns {array} of query objects grouped by tracker
	 */
	public getQueriesByTrackerList(trackerList, queryList) {
		return _.filter(trackerList, { canRead: true }).map((t) => {
			t.queries = _.filter(queryList, (q) => { return _.get(q, 'tracker.id', 0) == t.id; });
			return t;
		});
	}

	/**
	 * Given a project and tracker ids, retrieves the list of tracker
	 * queries under the given project
	 *
	 * @param {int} project Id
	 * @param {int} tracker id
	 * @returns {array} of query objects
	 */
	public getProjectQueries(project_id, trackerList, selectedTrackerId) {
		return new Promise((resolve, reject) => {
			try {
				this.trackerRest.projectQueries(0, {
					projectId:       project_id,
					selectedTracker: selectedTrackerId,
					page_size:       999
				})
				.then((response) => {
					resolve(this.addCustomQueries(
						this.getQueriesByTrackerList(trackerList, _.get(response, 'items', []))
					));
				}, () => {
					resolve([]);
				});
			} catch(err) {
				reject([]);
			}
		});
	}

	/**
	 * Given a tracker ID and query ID, saves the query user preference for the given tracker
	 *
	 * @param {int} tracker
	 * @param {int} query
	 */
	public saveCurrentTrackerQuery(tracker: string, query: string) {
		if (!this.userService.session.hasUser()) {
			return Promise.reject();
		}

		return new Promise((resolve, reject) => {
			this.userRest.saveUserPreference(this.userService.session.getUnixName(), 'query_tracker_' + tracker, query)
			.then(() => {
				resolve(null);
			}, () => {
				reject();
			});
		});
	}

	/**
	 * Given a tracker ID, retrieves the query user preference, if any
	 *
	 * @param {int} tracker
	 * @returns {object} query params
	 */
	public getCurrentTrackerQuery(tracker: number) {
		if (!this.userService.session.hasUser() || !(tracker > 0)) {
			return Promise.reject();
		}

		return new Promise((resolve, reject) => {
			this.userRest.getUserPreference(this.userService.session.getUnixName(), 'query_tracker_' + tracker, { default: false })
			.then((ret) => {
				resolve(ret);
			}, () => {
				reject();
			});
		});
	}

	public isCustomQuery(query_id) {
		return _.includes(query_id, 'custom_');
	}

	public getTrackerIdFromQueryId(query_id) {
		if (!_.isEmpty(query_id)) {
			return query_id.replace('custom_', '');
		}
		return null;
	}

	/**
	 * Given a tracker ID, retrieves the custom query saved parameters
	 *
	 * @param {int} tracker
	 * @returns {object} query params
	 */
	public getCustomQueryParams(tracker) {
		if (!this.userService.session.hasUser() || !(tracker > 0)) {
			return Promise.resolve(null);
		}

		return new Promise((resolve, reject) => {
			this.userRest.getUserPreference(this.userService.session.getUnixName(), 'custom_query_' + tracker)
			.then((response) => {
				var preferenceValue = _.get(response, 'preferenceValue', '{}');

				try {
					var _savedParams = JSON.parse(preferenceValue);
					_savedParams.page_num = this.stateService.params.page_num;
					_savedParams.page_size = this.stateService.params.page_size;

					resolve(_savedParams);
				}	catch(e) {
					resolve(null);
				}
			}, () => {
				resolve(null);
			});
		});
	}

	/**
	 * Given a tracker ID and a set of parameters, it persists them as a user preference
	 *
	 * @param {int} tracker
	 * @param {object} params
	 * @returns {object} query params
	 */
	public saveCustomQueryParams(tracker, params) {
		if (!this.userService.session.hasUser() || !(tracker > 0)) {
			return Promise.resolve(null);
		}

		return new Promise((resolve, reject) => {
			try {
				var _params = JSON.stringify(params);
				this.userRest.saveUserPreference(this.userService.session.getUnixName(), 'custom_query_' + tracker, _params)
				.then(() => {
					resolve(null);
				}, () => {
					reject(null);
				})
			} catch(err) {
				reject(null);
			}
		});
	}

	public isIntrinsic(field) {
		return _.has(this.queryFieldTypesToAlias, field.typeName);
	}

	public getIntrinsicAlias(field) {
		return _.get(this.queryFieldTypesToAlias, field.typeName, '');
	}

	public getFilterForQueryField(filters, queryField) {
		if (this.isIntrinsic(queryField)) {
			//Get the corresponding filter for this field
			return _.find(filters, {alias: this.getIntrinsicAlias(queryField)});
		} else {
			//Find extra field by Id
			return _.find(filters, {id: queryField.id});
		}
	}

	public setFilterDataForQueryField(filters, queryField) {
		var queryFilter = this.getFilterForQueryField(filters, queryField);

		if (queryFilter) {
			if (queryFilter.fieldType == 9) {
				this.mapValuesFromQueryToFilterDate(queryFilter, queryField);
			} else if ([10,11].includes(queryFilter.fieldType)) {
				this.mapValuesFromQueryToNumericRange(queryFilter, queryField);
			} else if ([20,22,24].includes(queryFilter.fieldType)) {
				this.mapValuesFromQueryToText(queryFilter, queryField);
			} else {
				//Get the values set in the query field
				this.mapValuesFromQueryToFilter(queryFilter, queryField);
			}
		}
		return queryField;
	}

	public setFilterDataFromQuery(filters, query) {
		query.queryFields = _.map(
			query.queryFields, (item) => {
				return this.setFilterDataForQueryField(filters, item);
			}
		);
	}

	public mapValuesFromQueryToFilter(queryFilter, queryField) {
		//Split the encoded query values
		var queryValues = _.split(queryField.value, ',');
		//Add query field type info
		queryFilter.queryFieldTypeId = queryField.type;
		queryFilter.queryFieldTypeName = queryField.typeName;

		//For each query value, find the data element in query Filter
		queryValues.forEach((queryValue) => {
			if (queryFilter.alias == 'lockStatus') {
				var values = this.trackerService.fields.builtIn.lock_status.getList(),
					value = _.find(values, {value: queryValue});

					if (!_.isEmpty(value)) {
					queryFilter.fieldData.push(value);
				}
			} else {
				//find the data element in query Filter
				var dataElement = _.find(queryFilter.fieldElements, {id: parseInt(queryValue)});

				//if the data element is found, set it to the field data array
				//(i.e.: selected filter elements for the query)
				if (!_.isEmpty(dataElement)) {
					if ([25, 26].indexOf(queryFilter.fieldType) != -1) {
						queryFilter.fieldData = dataElement;
					} else {
						if (!Array.isArray(queryFilter.fieldData)) {
							queryFilter.fieldData = [];
						}
						queryFilter.fieldData.push(dataElement);
					}
				} else if (queryFilter.alias == this.queryFieldTypesToAlias.FIELD_ASSIGNEE &&
						(queryValue == "-1" || queryValue == "-2")) {
					queryFilter.fieldData.push(this.assigneeSpecialFilters[queryValue]);
				} else if (queryFilter.fieldType == 7 && (queryValue == "-3" || queryValue == "-4")) {
					queryFilter.fieldData.push(this.statusSpecialFilters[queryValue]);
				}
			}

		});
	}

	public mapValuesFromQueryToText(queryFilter, queryField) {
		queryFilter.fieldData = queryField.value;
	}

	public mapValuesFromQueryToFilterDate(queryFilter, queryField) {
		queryFilter.startDate = "";
		queryFilter.endDate = "";

		if (!_.isEmpty(queryField)) {
			var splitDate = _.split(queryField.value, '|');
			if (splitDate.length == 3) {
				queryFilter.startDate = (moment(splitDate[0]).isValid()) ? moment(splitDate[0]).toString() : splitDate[0];
				queryFilter.endDate = (moment(splitDate[2]).isValid()) ? moment(splitDate[2]).toString() : splitDate[2];
			}
		}
	}

	public mapValuesFromQueryToNumericRange(queryFilter, queryField) {
		queryFilter.start = "";
		queryFilter.end = "";

		if (!_.isEmpty(queryField)) {
			var splitValue = _.split(queryField.value, '|');
			if (splitValue.length == 3) {
				queryFilter.start = (Number.isInteger(parseInt(splitValue[0]))) ? splitValue[0] : '';
				queryFilter.end = (Number.isInteger(parseInt(splitValue[2]))) ? splitValue[2] : '';
			}
		}
	}

	/*
	* Given a field type (string), returns corresponding the field type id
	*/
	public getQueryFieldTypeId(field_type) {
		return this.queryFieldTypes[field_type];
	}

	/*
	* Given a tracker and query objects, returns an array of filter objects
	* ready to be used for rendering selectors on the UI
	*/
	public mapQueryFieldsToFilters(filters, query) {
		var _res = _.filter(filters, (item) => {
			return ([1,2,3,5,7,8,9,10,11,12,20,22,23,24,25,26].includes(item.fieldType)) ? true : false;
		});

		_res.map((item) => {
			if (item.fieldType == 9) {
				item.startDateId = "start_" + item.alias;
				item.endDateId = "end_" + item.alias;
				item.startDate = '';
				item.endDate = '';
			} else if ([10,11].includes(item.fieldType)) {
				item.startId = "start_" + item.alias;
				item.endId = "end_" + item.alias;
				item.start = '';
				item.end = '';
			} else if ([20,22,24].includes(item.fieldType)) {
				item.fieldData = '';
			} else if ([26].includes(item.fieldType)) {
				let parentChildOptions = this.trackerFilterService.getParentChildRelationshipOptions();
				let option = parentChildOptions.find((option) => { return option.id == item.value; });
				item.fieldData = '';
				if (!_.isEmpty(option)) {
					item.fieldData = option;
				}
			} else {
				item.fieldData = [];
			}
		});

		this.setFilterDataFromQuery(_res, query);
		return _res;
	}

	/*
	* Given a tracker and query objects, returns an array of filter objects
	* ready to be used for rendering selectors on the UI
	*/
	public mapQuerySortByFieldToFilter(tracker, query) {
		var fieldSortBy = {
			sortField: {
				fieldElements: [],
				fieldData: null
			},
			sortOrd: {
				fieldElements: [],
				fieldData: null
			}
		};

		var enabledFields = [];
		_.forOwn(tracker.fields, (field) => {
			if (!field.isExtraField) {
				enabledFields.push(_.cloneDeep(field));
			}
		});

		enabledFields.unshift({alias: "id", fieldName: "ID"});
		enabledFields.push({alias: "submittedBy", fieldName: "Submitted By"});
		enabledFields.push({alias: "lastModifiedDate", fieldName: "Last Modified Date"});

		//Get available sort fields
		fieldSortBy.sortField.fieldElements = enabledFields.map((item) => {
			return {id: item.alias, label: item.fieldName};
		});

		//Get the currently selected sort field
		var sortField = _.find(query.queryFields, {typeName: "FIELD_SORTCOL"});

		if (!_.isEmpty(sortField)) {
			var fieldSortByElement = _.find(fieldSortBy.sortField.fieldElements, {id: sortField.value});

			if (!_.isEmpty(fieldSortByElement)) {
				fieldSortBy.sortField.fieldData = fieldSortByElement;
			}
		}

		//Get the sort order
		var sortAsc = {id: 1, label: "Ascending"},
			sortDesc = {id: 2, label: "Descending"};

		fieldSortBy.sortOrd = {
			fieldElements: [sortAsc, sortDesc],
			fieldData: null
		};

		var sortFieldOrd = _.find(query.queryFields, {typeName: "FIELD_SORTORD"});

		if (!_.isEmpty(sortFieldOrd) && ["ASC", "DESC"].includes(sortFieldOrd.value)) {
			fieldSortBy.sortOrd.fieldData = (sortFieldOrd.value == "ASC") ? sortAsc : sortDesc;
		} else {
			fieldSortBy.sortOrd.fieldData = sortAsc;
		}

		return fieldSortBy;
	}

	/*
	* Given a tracker and query objects, returns a filter object
	* reprenting the fields to display settings
	* ToDo: Remove this, display fields are deprecated in GF Next
	*/
	public mapQueryFieldsToDisplayToFilter(tracker, query) {
		var fieldsToDisplay = {
				fieldElements: [],
				fieldData: []
		};

		//Get available fields to display
		fieldsToDisplay.fieldElements =  _.filter(tracker.fields, (item) => {
				return (item.isExtraField) ? true : false;
		}).map((item) => {
				return {id: item.id, alias: item.alias, label: item.fieldName};
		});

		//Map each available display column

		_.forEach(query.queryDisplayColumns, (displayColumn) => {
				var fieldData = _.find(fieldsToDisplay.fieldElements, {id: displayColumn.fieldId});

				if (fieldData) {
					fieldsToDisplay.fieldData.push(fieldData);
				}
		});

		return fieldsToDisplay;
	}

	/*
	* Given a tracker and a query field type (string representation)
	* returns an object with two properties with the start and end date values
	* @param {object} query
	* @param {string} field_type
	* @return {object} of type {startDate: STRING, endDate: STRING}
	*/
	public mapQueryDateField(query, field_type) {
		var res = {
			startDate: "",
			endDate: ""
		};

		var dateField = _.find(query.queryFields, {typeName: field_type});
		if (!_.isEmpty(dateField)) {
			var splitDate = _.split(dateField.value, '|-|');
			
			res.startDate = splitDate[0]?.length > 0 ? splitDate[0] : "";
			res.endDate = splitDate[1]?.length > 0 ? splitDate[1] : "";
		}

		return res;
	}

	/*
	* Given a tracker and a query field type (string representation)
	* returns an object with two properties with the start and end date values
	* @param {object} query
	* @param {string} field_type
	* @return {object} of type {startDate: STRING, endDate: STRING}
	*/
	public mapQueryDatesToQueryDateObject(query) {
		return {
			FIELD_OPENDATE: this.mapQueryDateField(query, "FIELD_OPENDATE"),
			FIELD_CLOSEDATE: this.mapQueryDateField(query, "FIELD_CLOSEDATE"),
			FIELD_MODDATE: this.mapQueryDateField(query, "FIELD_MODDATE")
		};
	}

	/*
	* Encodes an array of field filters into the query object
	* @param {array} filters
	* @param {object} query
	*/
	public mapFiltersToQueryFields(filters, query) {
		var _queryField, _queryFields = [];

		_.forEach(filters, (filter) => {
			//Check if there's already a query Field for this
			var queryFieldTypeName  = this.aliasToQueryFieldType[filter.alias],
					queryFieldTypeId;

			if (!filter.isExtraField) {
				//It's an intrinsic field
				queryFieldTypeName  = this.aliasToQueryFieldType[filter.alias];
				queryFieldTypeId = this.queryFieldTypes[queryFieldTypeName];
				_queryField = _.find(query.queryFields, {typeName: this.aliasToQueryFieldType[filter.alias]});
			} else {
				//It's an extra field
				queryFieldTypeName = "FIELD_EXTRAFIELD";
				queryFieldTypeId = 4;
				var val;
				_queryField = _.find(query.queryFields, {id: filter.id});
			}

			//If not found, create it
			if (_.isEmpty(_queryField)) {
				_queryField = {
					id: (filter.id) ? filter.id : 0,
					type: queryFieldTypeId,
					typeName: queryFieldTypeName,
					value: ""
				};
			}

			//Map values from filter to query field
			if (filter.fieldType == 9) {
				//The field is of type date
				_queryField.value = (filter.startDate != ""  || filter.endDate != "") ?
									filter.startDate + "|-|" + filter.endDate : "";
			} else if (filter.fieldType == 10 || filter.fieldType == 11) {
					//The field is of type date
					_queryField.value = (filter.start != "" && filter.end != "") ?
										filter.start + "," + filter.end : "";
			} else if (!filter.isExtraField && filter.alias == 'lockStatus') {
				_queryField.value = _.toString(_.map(filter.fieldData, (item) => {
					var val_maps = {'00': 0, "01": 1, "02": 2};

					return _.get(val_maps, item.id, '');
				}));
				filter.fieldType = 23;
			} else {
				if (typeof filter.fieldData === 'string') {
					_queryField.value = filter.fieldData;
				} else {
					if (Array.isArray(filter.fieldData)) {
						_queryField.value = _.toString(_.map(filter.fieldData, (item) => {
							return item.id;
						}));
					} else {
						_queryField.value = _.toString(_.get(filter, 'fieldData.id', ''));
					}
				}
			}

			//The following logic validates filters, based on criteria like field type and extra vs non-extra field type
			//If a filter doesn't pass validation, is not added to the query filters list for being persisted.
			if (
				//If it's an extra field of select type, then no empty or zero values are allowed
				([1,2,3,5,7,8,12].includes(filter.fieldType) && filter.isExtraField && _queryField.value != "" && _queryField.value != "0") ||
				//If it's an extra field of text type, then no empty values are allowed
				([4,6,9].includes(filter.fieldType) && filter.isExtraField && _queryField.value != "" && _queryField.value != "0") ||
				//If it's a special filter of type select, then no empty values or zero values are allowed
				([1,10,11,12,13,25,26].includes(filter.fieldType) && !filter.isExtraField && _queryField.value != "" && _queryField.value != "0") ||
				//If it's a special filter of type text, then no empty values are allowed
				([3,5,6,7,8,20,21,22,24].includes(filter.fieldType) && !filter.isExtraField && _queryField.value != "")
				) {
				_queryFields.push(_queryField);
			} else if (
				//If it's not a field that requires a special value validation, then just add it to the query
				!([1,2,3,4,5,6,7,8,9,12].includes(filter.fieldType) && filter.isExtraField) &&
				!([1,3,5,6,7,8,10,11,12,13,20,21,22,24,25,26,27].includes(filter.fieldType) && !filter.isExtraField)
			) {
				_queryFields.push(_queryField);
			}
		});

		query.queryFields = _queryFields;
	}

	public mapQueryDatesObjectToQuery(query_dates, query) {
		["FIELD_OPENDATE", "FIELD_CLOSEDATE", "FIELD_MODDATE"].forEach((item) => {
			var queryDate = _.find(query.queryFields, {typeName: item});

			if (_.isEmpty(queryDate)) {
				queryDate = {
					id: 0,
					type: this.queryFieldTypes[item],
					typeName: item,
					value: ""
				};

				query.queryFields.push(queryDate);
			}

			queryDate.value = (query_dates[item].startDate != "" || query_dates[item].endDate != "") ?
								query_dates[item].startDate + "|-|" + query_dates[item].endDate : "";
		});
	}

	/**
	 * ToDo: Remove this, display fields are deprecated in GF Next
	 */
	public mapFieldsToDisplayToQuery(fields_to_display, query) {
		query.queryDisplayColumns = _.map(fields_to_display.fieldData, (item) => {
			return {fieldId: item.id, fieldOrder: null};
		});
	}

	public mapFieldSortByToQuery(field_sort_by, query) {
		var fieldSortCol = (!_.isEmpty(field_sort_by.sortField.fieldData)) ? field_sort_by.sortField.fieldData : null,
			fieldSortOrd = (!_.isEmpty(field_sort_by.sortOrd.fieldData)) ? field_sort_by.sortOrd.fieldData : null,
			querySortCol = {
				type: "5",
				id: 0,
				typeName: "FIELD_SORTCOL",
				value: ""
			},
			querySortOrd = {
				type: "6",
				id: 0,
				typeName: "FIELD_SORTORD",
				value: ""
			};

		//Remove current sort config from the query object
		_.remove(query.queryFields, {typeName: "FIELD_SORTCOL"});
		_.remove(query.queryFields, {typeName: "FIELD_SORTORD"});

		//If there's no selected sort field, then exit
		if (_.isEmpty(fieldSortCol)) {
			return;
		}

		//To setup the query sort ID property, check if it's an intrinsic field, if not, it's an extra field
		if (_.includes(this.aliasToQueryFieldType, fieldSortCol.id)) {
			querySortCol.value = this.aliasToQueryFieldType[fieldSortCol.id];
		} else {
			querySortCol.value = fieldSortCol.id;
		}

		//Check if sort ord is set, otherwise, set "DESC" by default
		if (!_.isEmpty(fieldSortOrd) && fieldSortOrd.id == 1) {
			querySortOrd.value = "ASC";
		} else {
			querySortOrd.value = "DESC";
		}

		//Set the new config in the query object
		query.queryFields.push(querySortCol);
		query.queryFields.push(querySortOrd);
	}

	public getQueryExportUrl(query, format) {
		var ret = "/api/trackeritem?mode=ungrouped&query=:queryId&tracker=:trackerId&download=true&format=:format";

		ret = ret.replace(":queryId", String(query.id));
		ret = ret.replace(":trackerId", String(query.tracker.id));
		ret = ret.replace(":format", format);

		return ret;
	}

	    /**
     * Retrieves the query id, attempts to recover the saved preference query, if any
     * @returns {string} query id
     */
		public getQueryPreferenceForTracker(tracker, query) {
			var isScalar = function(value) {
				return !(Array.isArray(value) || _.isObject(value));
			};
	
			var isValid = function(value) {
				if (_.isEmpty(value)) return false;
				if (! isScalar(value)) return false;
				return !(['false', 0].includes(value));
			};
	
			var defaultValue = 'custom_' + tracker;
	
			return new Promise((resolve, reject) => {
				if (isValid(query)) {
					resolve(query);
					return;
				}
	
				this.getCurrentTrackerQuery(tracker)
				.then((ret) => {
					var value = _.get(ret, 'preferenceValue', defaultValue);
					if (! isValid(value)) {
						value = defaultValue;
					}
					resolve(value);
				}, () => {
					resolve(defaultValue);
				});
	
			});
		};
}
